import { ENV as COMMON_ENV } from '@ar2/common';

// tslint:disable-next-line:missing-jsdoc
export const ENV = COMMON_ENV;



// WEBPACK FOOTER //
// ./src/config/config.default.ts